module.exports = __webpack_public_path__ + "static/img/home-env.fa1495ba.png";